<template>
    <transition name="slide">
        <div class="gdpr" v-if="visible">
            <div class="has-overflow" data-flex="row center" data-v-animate>
                <p>{{ text }}</p>
                <button class="button button--purple" @click.prevent="accept()">Get it!</button>
            </div>
        </div>
    </transition>
</template>

<style lang="scss" scoped>
.slide-enter, .slide-leave-to {
    transform: translate3d(0, 111%, 0);
    opacity: 0
}
.slide-enter-to {
    transition: all .25s .75s ease
}
.slide-leave-active {
    transition: all .3s ease-in
}
</style>

<script>
export default {
    name: 'CookiePopup',
    props: {
        text: {
            type: String,
            default: 'This website uses cookies to ensure you get the best experience on our website.'
        }
    },
    data() {
        return {
            visible: false,
            accepted: false,
            europe: [
                'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DE', 'DK', 'EE', 'EL',
                'ES', 'FI', 'FR', 'GB', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV',
                'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'
            ]
        }
    },
    mounted() {
        const vm = this

        // localStorage.removeItem('gdpr')

        if ( ! localStorage.gdpr ) fetch('https://api.ipdata.co/?api-key=ea78028cb0bfd25acea31a9c329ea9d43f0d61409d2c849d2aea1c24')
        .then( response => response.json() )
        .then( result => {
            if ( vm.isEurope( result.country_code ) ) {
                vm.visible = true
            }
        })

    },
    methods: {
        isEurope( location ) {
            return this.europe.includes( location )
        },
        accept() {
            if ( !localStorage.gdpr ) {
                localStorage.gdpr = this.accepted = true
                this.visible = false
            }
        }
    }
}
</script>
